import { render, staticRenderFns } from "./others.vue?vue&type=template&id=798b970a&scoped=true&"
var script = {}
import style0 from "./others.vue?vue&type=style&index=0&id=798b970a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b970a",
  null
  
)

export default component.exports